import 'echarts';

export default {
    tooltip: {
        trigger: 'axis',
        axisPointer: {
            type: 'shadow',
        },
        formatter: '{a0}: {c0}<br/>{a1}: {c1}'
    },
    grid: {
        left: 40,
        right: 40,
    },
    legend: {
        bottom: 0
    },
    dataZoom: {
        show: false,
        start: 0,
        end: 100
    },
    xAxis: [
        {
            type: 'category',
            boundaryGap: true,
            data: [],
            min: 0
        }
    ],
    yAxis: [
        {
            type: 'value',
            scale: true,
            name: '',
            boundaryGap: [0.2, 0.2],
            min: 0
        },
        {
            type: 'value',
            scale: true,
            name: '',
            boundaryGap: [0.2, 0.2],
            min: 0
        }
    ],
    series: [
        {
            name: '',
            type: 'bar',
            yAxisIndex: 0,
            data: [],
            itemStyle: {}
        },
        {
            name: '',
            type: 'line',
            smooth: true,
            yAxisIndex: 1,
            data: [],
            showSymbol: false,
        }
    ]
};
